import { tabClasses } from "@mui/material/Tab";
// ----------------------------------------------------------------------
export function tabs(theme) {
    return {
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: theme.palette.text.primary,
                },
                scrollButtons: {
                    width: 48,
                    borderRadius: "50%",
                },
            },
        },
        MuiTabPanel: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    py: 0,
                    px: 1,
                    borderRadius: '12px 12px 0 0',
                    opacity: 1,
                    minHeight: 48,
                    fontSize: theme.typography.subtitle2,
                    fontWeight: theme.typography.fontWeightSemiBold,
                    "&:not(:last-of-type)": {
                        marginRight: theme.spacing(1.5),
                        [theme.breakpoints.up("sm")]: {
                            marginRight: theme.spacing(1),
                        },
                    },
                    [`&:not(.${tabClasses.selected})`]: {
                        color: theme.palette.grey[600],
                        fontWeight: 400,
                    },
                    [`&.${tabClasses.selected}`]: {
                        color: theme.palette.common.black,
                        fontWeight: 400,
                    },
                },
            },
        },
    };
}
